import { Component, SimpleChanges, Input } from '@angular/core';
import { GlobalsSingleton } from '../../../app/core/GlobalsSingleton';
import { eGENA_Checkliste } from '../../../visionet/Checkliste';


@Component({
	selector: 'AlphabetischeSuche',
	templateUrl: 'AlphabetischeSuche.html'
})

export class AlphabetischeSucheComponent {

	@Input()
	azIndex: Map<string, eGENA_Checkliste[]> =  new Map();
	@Input()
	curSearchResultChecklists: eGENA_Checkliste[]
	@Input()
	ausgewaehlterPatiententyp: string;
	@Input()
	activeSearch: string = ''




	azButtons: string[] = []


	constructor(public globals: GlobalsSingleton) {
		// Die Buchstaben-Buttons A...Z generieren
		for (let i = 65; i < 91; i++) {
			this.azButtons.push(String.fromCharCode(i))
		}
	}


	/**	=== Visionet(sl) ==========
	 *
	 *	Lade die Trefferliste für den Buchstaben (A-Z) in die aktuelle Trefferliste
	 */
	ladeTrefferFuerAZ_Suche(letter : string) : void {
		this.curSearchResultChecklists = this.azIndex[letter]
	}



	/**	=== Visionet(sl) ==========
	 *
	 *	Hier wird geregelt, ob ein Buchstabe des ABC in der Trefferliste der A-Z-Suche dargestellt wird oder nicht
	 *	(weil es zu diesem Buchstaben keine Treffer gibt).
	 *	Umgekehrte Logik:
	 *
	 *	@returns `true` wenn der Buchstabe NICHT anklickbar sein soll
	 */
	azDisableButton(letter : string) : boolean {
		let list : eGENA_Checkliste[] = this.azIndex[letter]

		if (list == undefined){
			return true;
		}
		var arr = []

		let ausgewaehlterPatiententyp = this.ausgewaehlterPatiententyp;
		arr = list.filter(function(checkliste) {
			return checkliste.patientengruppe == ausgewaehlterPatiententyp;
		})

		return arr.length == 0
	}





	/**	=== Visionet(sl) ==========
	 *
	 *	In der Tablet-Variante werden Buchstaben, zu denen keine Trefferliste existiert zwar dargestellt,
	 *	aber, siehe `azDisableButton`, disabled.
	 *	In der Telefon-Variante werden sie aber aus Platzgründen nicht gargestellt. Hier wird eine passende
	 *	CSS-Klasse generiert
	 *	{@linkcode azDisableButton}
	 *
	 *	@returns `"visibleAZbutton"` wenn der Buchstabe angezeigt werden soll, `"invisibleAZbutton"` wenn er nicht angezeigt werden soll.
	 */
	azButtonClass(letter : string) : string {
		if (!this.globals.isPhone())
			return "visibleAZbutton";

		let list : eGENA_Checkliste[] = this.azIndex[letter]

		if (list == undefined){
			return "invisibleAZbutton";
		}
		var arr = []

		let ausgewaehlterPatiententyp = this.ausgewaehlterPatiententyp;
		arr = list.filter(function(checkliste) {
			return checkliste.patientengruppe == ausgewaehlterPatiententyp;
		})

		if (arr.length != 0)
			return "visibleAZbutton";
		else
			return "invisibleAZbutton";
	}


	isTablettOrPc() : boolean {
		return !this.globals.isPhone();
	}

}



// WEBPACK FOOTER //
// ./src/components/Suche/AlphabetischeSuche/AlphabetischeSuche.ts